// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-school-text {
    margin-bottom: 13vw !important;

}

.video-school-text2 {  
    margin-left: 10vw;
    }

.text-padding {
    padding-left: 9.5vw;
}

.center-text-padding{
    padding-left: 17vw;
  }

.text-top {
    padding-top: 9vw;
}

@media screen and (max-width: 575px){ 
    .text-top {
        padding-top: 50vw;
    }

    .center-text-padding{
        padding-left: 0vw;
      }
}
.video-background {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }
  
  .vp-container {
    position: relative;
    /* z-index: 2; */
  }
  
  .video-text {
    color: #ffe6c8;
    text-align: center;
    bottom: 100px;
    z-index: 2;
    position: relative;
    top:6rem;
  }
  
  .mainPageContainer {
    display: flex;
    justify-content: center !important;
    align-items: center !important;
    height: 100%;
  }
  
  .main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .text-sm {
    font-size: 1.5rem;
  }
  
  .light-col {
    color: #ffe6c8;
  }
  
  .mobile-heading {
    font-family: 'Montserrat', sans-serif;
  }
  
  .montser-lrg {
    font-size: 1.25rem !important;
    font-family: 'Montserrat', sans-serif !important;
  }
  .montser-lrg-1_2rem {
    font-size: 1.2rem !important;
    font-family: 'Montserrat', sans-serif !important;
  }
  @media only screen and (max-width: 991px) {
    .montser-lrg, .reg-montser-lrg {
        font-family: 'Montserrat-large' !important;
        font-size: 2vh !important;
        font-weight: 100 !important;
        font-style: normal !important;
    }
}
  
  .montser-mdm-2 {
    font-size: 1rem !important;
    font-family: 'Montserrat', sans-serif;
  }
  .montser-mdm-1-5rem{
    font-size: 1.5rem !important;
    font-family: 'Montserrat-large';
  }
  .montser-mdm-1-2rem{
    font-size: 1.2rem !important;
    font-family: 'Montserrat-large';
  }
 .about-btn, .select-btn, .btn-sm, .btn-md, .btn-lg {
    background-color: #83B06D;
    color:#1c2933;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
  }

  .btn-sm{
    width: 5rem;
  }
  
  .btn-md{
    width: 10rem;
  }

  .btn-lg{
    width: 15rem;
  }

 
  .join-btn:hover, .about-btn:hover, .select-btn:hover, .btn-sm:hover, .btn-md:hover,  .btn-lg:hover {
    background-color: #83B06D;
  }
  /* .about :hover {
    color: #1c2933 !important;
    background-color: #fee6c8;
  } */
  
  .about {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    top:5rem;
    z-index: 1;
  }
  .v-about {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    bottom:0rem;
    z-index: 1;
  }
  
  .about-btn {
    margin-bottom: 10px;
  }
  
  a.text-light {
    color: #ffe6c8 !important;
    text-decoration: none;
    margin-left: 15px;
  }
  
  a.text-light:hover {
    text-decoration: underline;
  }

  .modal-content {
    background: #E2EECC !important;
    color: #1c2933  !important;
    padding: 20px;
    border-radius: 8px;
    max-width: 80%; /* Prevent the modal from stretching too wide */
    max-height: 90%; /* Prevent the modal from stretching too tall */
    overflow-y: auto; /* Add scroll if content exceeds the height */
    z-index: 1001;
    position: relative;
    border-radius: 0.5vw 0.5vw 0.5vw 0.5vw !important;
  }
  
  .modal-header .close-button {
    background: transparent;
    border: none;
    font-size: 1.5rem;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    color: #333;
  }

.modal-image {
  height: 100px;
  border-radius: 50%;
}
.img-l {
    width: 5rem !important;
    display: flex;
    height: 4rem;
}
.graph-svg{
    width:25vw !important;
}
.text-left{
  text-align: left !important;
}

/* videobackground.css */

/* General styles for video and text */
.v-video-overlay {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 1;
  width: 100%;
  padding: 0 15px;
  background-color: rgba(0, 0, 0, 0.4);
  height: 120%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0.5;
}
.video-overlay{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 1;
  width: 90%;
  height: 90%;
  padding: 0 15px;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .video-overlay h1 {
    font-size: 2rem; /* Smaller font size for mobile */
  }

  .video-overlay button {
    font-size: 0.9rem; /* Adjust button font size */
    padding: 0.75rem 1.25rem; /* Adjust padding for mobile */
  }
  .container-e .d-flex {
    display: block !important;
  }
}

@media (max-width: 576px) {
  .video-overlay h1 {
    font-size: 1.8rem; /* Smaller font size for extra small screens */
    margin-top: 5rem;
  }

  .video-overlay button {
    font-size: 0.8rem; /* Even smaller button size */
    padding: 0.5rem 1rem; /* Smaller padding for extra small screens */
  }
  .carousel-inner video {
    height: auto; /* Make height adjust automatically on mobile */
    max-height: 100vh; /* Ensure video doesn't exceed the viewport height */
    margin-top: 5vh;    
  }
}

/* Adjust for mobile responsiveness */
@media (max-width: 768px) {
  .carousel-inner video {
    height: auto; /* Make height adjust automatically on mobile */
    max-height: 100vh; /* Ensure video doesn't exceed the viewport height */
    margin-top: 7rem;
  }
  #carouselExampleSlidesOnly{
    height:35rem !important;
  }
  .video-overlay {
    top: 30%;
    transform: translate(-50%, -50%);
    height: 80%,  !important;
  }

  .about {
    margin-top: 20px; /* Reduce the gap between the button and the video */
  }

  /* Ensure no extra space after the button */
  .carousel-item {
    padding-bottom: 0;
  }

  /* Adjust the height to fit content and remove extra space */
  .carousel-inner {
    padding-bottom: 0;
  }

  /* Reduce the space below the video */
  .m-4.mt-4 {
    margin-bottom: 0;
  }
}

@media (min-width: 992px) {
  .about button {
    display: grid;
    align-content: center;
  }
  .para{
    text-align: left !important;
    padding-left: 10rem;
    padding-right: 10rem;
  }
  .navbar-brand{
    margin-top:0.5rem !important;
  }
}
@media (max-width: 768px) {
  .row {
    padding-left: 15px;
    padding-right: 15px;
  }
  .about ,.v-about{
    display: flex;
    flex-direction: column;
    align-items: center;
    position:none;
    top:8rem;
  }
  .video-bg-1{
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .mob-social-link{
    position:relative;
    top:15rem;
  }
}

.scrollable-dropdown {
  max-height: 150px; /* Adjust height as needed */
  overflow-y: auto;  /* Enable vertical scrolling */
}

.video-overlay .dropdown-menu>li{
  border-bottom: 1px solid #ccc !important;
}
.dropdown-toggle::after{
  margin-left:1rem !important;
}

.btn-md:hover{
  background-color: #1c2933;
  color:#83B06D
}
.btn-hover-effect {
  transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-hover-effect:hover {
  background-color: var(--font-color) !important;
  color: var(--background-color) !important;
}

@media (min-width: 768px) {
  .flex-md-row {
      flex-direction: row !important;
      margin-top: 4rem !important;
  }
  .socialLinks{
    position: absolute;
    bottom: 0rem;
    padding-right:5.5rem !important;
    padding-left: 6.5rem !important;
  }
}

/* General modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80vw;
  height: 100vh;
  z-index: 1000;
}


.close-button {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
}

/* Responsive adjustments for mobile */
@media (max-width: 768px) {
  .modal-content {
      max-width: 95%;
      padding: 15px;
  }

  .img-l {
      width: 8rem;
      margin-bottom: 1rem;
  }

  .d-flex.mt-2.pr-4.gap-2 {
      flex-direction: column;
      align-items: center;
      gap: 1rem;
  }

  .d-flex.flex-column.text-start {
      width: auto;
      margin-bottom: 1rem;
      text-align: center;
  }

  .d-flex.flex-column.justify-content-center.text-left {
      width: auto;
      margin-top: 1rem;
  }

  .container-e.px-5.d-flex.flex-wrap.justify-content-around.pt-5 {
      padding: 0;
      margin-top: 2rem;
      flex-direction: column;
      align-items: center;
  }

  .graph-svg {
      margin-bottom: 2rem;
  }

  .video-container {
      margin-top: 1.5rem;
  }

  .montser-mdm {
      font-size: 1rem !important;  /* Adjusted font size for mobile */
  }

  .mute-toggle {
      top: 5px;
      right: 5px;
      padding: 5px;
  }
  .modal-overlay {
    position: fixed; /* Stays fixed relative to the viewport */
    top: 4rem;
    left: 0;
    width: 100vw; /* Full viewport width */
    height: 80vh; /* Full viewport height */
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem; /* 1rem gap on all sides */
    box-sizing: border-box; /* Includes padding in width and height calculations */
    z-index: 1000; /* Ensures it's on top of other elements */
}

/* Modal Content */
.modal-content {
    background: white; /* Background color of the modal */
    border-radius: 8px; /* Rounded corners */
    max-width: 100%; /* Ensures it doesn't exceed the viewport */
    width: 500px; /* Fixed width for larger screens */
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* Adds shadow for depth */
    padding: 20px; /* Internal padding */
    position: relative; /* For positioning child elements if needed */
    overflow-y: auto; /* Allows scrolling if content is too tall */
}

}

/* Responsive adjustments for smaller devices */
@media (max-width: 600px) {
  .modal-content {
      width: 100%; /* Occupies full width minus the 1rem padding */
      padding: 15px; /* Reduce padding */
  }
}

.d-flex.mt-2.pr-4.gap-2 {
  width: 100%;
  margin-left: 2.5rem;  /* Apply margin-left for large screens */
}

/* Remove margin-left for small screens */
@media (max-width: 768px) {
  .d-flex.mt-2.pr-4.gap-2 {
      margin-left: 0;  /* Remove margin-left for small screens */
  }
  .text-div {
    width: 20rem;
    margin-bottom: 1rem;  /* Add margin-bottom for small screens */
}
.text-container {
  width: 19rem;
  margin-right: 0rem !important;
}
.graph-svg {
  width:20rem !important;
  margin-bottom: 1rem !important;
}
.text-div span {
  display: block !important;
}
.m-container-e{
  margin-left:2rem;
  margin-right: 1rem;
}
.socialLinks{
  position: relative !important;
  bottom:19rem !important;
}
}

.text-div {
  width: 20vw;
  margin-bottom: 0; 
}

.text-container {
  width: 30vw;
  margin-right: 3rem;
  position: relative;
}

.container-e{
  overflow-x: hidden;
}

@media(min-width: 992px) {
  .navbar-expand-lg .navbar-nav {
    margin-left:5rem !important;
  }}`, "",{"version":3,"sources":["webpack://./src/components/videobackground.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;;AAElC;;AAEA;IACI,iBAAiB;IACjB;;AAEJ;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;EACpB;;AAEF;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;MACnB;AACN;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,6BAA6B;IAC7B,gDAAgD;EAClD;EACA;IACE,4BAA4B;IAC5B,gDAAgD;EAClD;EACA;IACE;QACI,0CAA0C;QAC1C,yBAAyB;QACzB,2BAA2B;QAC3B,6BAA6B;IACjC;AACJ;;EAEE;IACE,0BAA0B;IAC1B,qCAAqC;EACvC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;CACD;IACG,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qCAAqC;EACvC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,yBAAyB;EAC3B;EACA;;;KAGG;;EAEH;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;IAClB,cAAc,EAAE,+CAA+C;IAC/D,eAAe,EAAE,+CAA+C;IAChE,gBAAgB,EAAE,6CAA6C;IAC/D,aAAa;IACb,kBAAkB;IAClB,iDAAiD;EACnD;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,WAAW;EACb;;AAEF;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;;AAExB,sCAAsC;AACtC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe,EAAE,iCAAiC;EACpD;;EAEA;IACE,iBAAiB,EAAE,4BAA4B;IAC/C,wBAAwB,EAAE,8BAA8B;EAC1D;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,8CAA8C;IACjE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB,EAAE,6BAA6B;IAChD,oBAAoB,EAAE,4CAA4C;EACpE;EACA;IACE,YAAY,EAAE,+CAA+C;IAC7D,iBAAiB,EAAE,oDAAoD;IACvE,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,YAAY,EAAE,+CAA+C;IAC7D,iBAAiB,EAAE,oDAAoD;IACvE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB,EAAE,oDAAoD;EACxE;;EAEA,2CAA2C;EAC3C;IACE,iBAAiB;EACnB;;EAEA,4DAA4D;EAC5D;IACE,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,QAAQ;EACV;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE,iBAAiB,EAAE,4BAA4B;EAC/C,gBAAgB,GAAG,8BAA8B;AACnD;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB;AACF;AACA;EACE,uDAAuD;AACzD;;AAEA;EACE,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE;MACI,8BAA8B;MAC9B,2BAA2B;EAC/B;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,+BAA+B;IAC/B,+BAA+B;EACjC;AACF;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,aAAa;AACf;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE;MACI,cAAc;MACd,aAAa;EACjB;;EAEA;MACI,WAAW;MACX,mBAAmB;EACvB;;EAEA;MACI,sBAAsB;MACtB,mBAAmB;MACnB,SAAS;EACb;;EAEA;MACI,WAAW;MACX,mBAAmB;MACnB,kBAAkB;EACtB;;EAEA;MACI,WAAW;MACX,gBAAgB;EACpB;;EAEA;MACI,UAAU;MACV,gBAAgB;MAChB,sBAAsB;MACtB,mBAAmB;EACvB;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,0BAA0B,GAAG,kCAAkC;EACnE;;EAEA;MACI,QAAQ;MACR,UAAU;MACV,YAAY;EAChB;EACA;IACE,eAAe,EAAE,yCAAyC;IAC1D,SAAS;IACT,OAAO;IACP,YAAY,EAAE,wBAAwB;IACtC,YAAY,EAAE,yBAAyB;IACvC,8BAA8B,EAAE,gCAAgC;IAChE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,0BAA0B;IACzC,sBAAsB,EAAE,sDAAsD;IAC9E,aAAa,EAAE,0CAA0C;AAC7D;;AAEA,kBAAkB;AAClB;IACI,iBAAiB,EAAE,kCAAkC;IACrD,kBAAkB,EAAE,oBAAoB;IACxC,eAAe,EAAE,2CAA2C;IAC5D,YAAY,EAAE,mCAAmC;IACjD,yCAAyC,EAAE,0BAA0B;IACrE,aAAa,EAAE,qBAAqB;IACpC,kBAAkB,EAAE,6CAA6C;IACjE,gBAAgB,EAAE,4CAA4C;AAClE;;AAEA;;AAEA,+CAA+C;AAC/C;EACE;MACI,WAAW,EAAE,+CAA+C;MAC5D,aAAa,EAAE,mBAAmB;EACtC;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB,GAAG,wCAAwC;AAChE;;AAEA,yCAAyC;AACzC;EACE;MACI,cAAc,GAAG,yCAAyC;EAC9D;EACA;IACE,YAAY;IACZ,mBAAmB,GAAG,wCAAwC;AAClE;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;EAC7B,CAAC","sourcesContent":[".video-school-text {\n    margin-bottom: 13vw !important;\n\n}\n\n.video-school-text2 {  \n    margin-left: 10vw;\n    }\n\n.text-padding {\n    padding-left: 9.5vw;\n}\n\n.center-text-padding{\n    padding-left: 17vw;\n  }\n\n.text-top {\n    padding-top: 9vw;\n}\n\n@media screen and (max-width: 575px){ \n    .text-top {\n        padding-top: 50vw;\n    }\n\n    .center-text-padding{\n        padding-left: 0vw;\n      }\n}\n.video-background {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n  }\n  \n  .vp-container {\n    position: relative;\n    /* z-index: 2; */\n  }\n  \n  .video-text {\n    color: #ffe6c8;\n    text-align: center;\n    bottom: 100px;\n    z-index: 2;\n    position: relative;\n    top:6rem;\n  }\n  \n  .mainPageContainer {\n    display: flex;\n    justify-content: center !important;\n    align-items: center !important;\n    height: 100%;\n  }\n  \n  .main-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .text-sm {\n    font-size: 1.5rem;\n  }\n  \n  .light-col {\n    color: #ffe6c8;\n  }\n  \n  .mobile-heading {\n    font-family: 'Montserrat', sans-serif;\n  }\n  \n  .montser-lrg {\n    font-size: 1.25rem !important;\n    font-family: 'Montserrat', sans-serif !important;\n  }\n  .montser-lrg-1_2rem {\n    font-size: 1.2rem !important;\n    font-family: 'Montserrat', sans-serif !important;\n  }\n  @media only screen and (max-width: 991px) {\n    .montser-lrg, .reg-montser-lrg {\n        font-family: 'Montserrat-large' !important;\n        font-size: 2vh !important;\n        font-weight: 100 !important;\n        font-style: normal !important;\n    }\n}\n  \n  .montser-mdm-2 {\n    font-size: 1rem !important;\n    font-family: 'Montserrat', sans-serif;\n  }\n  .montser-mdm-1-5rem{\n    font-size: 1.5rem !important;\n    font-family: 'Montserrat-large';\n  }\n  .montser-mdm-1-2rem{\n    font-size: 1.2rem !important;\n    font-family: 'Montserrat-large';\n  }\n .about-btn, .select-btn, .btn-sm, .btn-md, .btn-lg {\n    background-color: #83B06D;\n    color:#1c2933;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    font-family: 'Montserrat', sans-serif;\n  }\n\n  .btn-sm{\n    width: 5rem;\n  }\n  \n  .btn-md{\n    width: 10rem;\n  }\n\n  .btn-lg{\n    width: 15rem;\n  }\n\n \n  .join-btn:hover, .about-btn:hover, .select-btn:hover, .btn-sm:hover, .btn-md:hover,  .btn-lg:hover {\n    background-color: #83B06D;\n  }\n  /* .about :hover {\n    color: #1c2933 !important;\n    background-color: #fee6c8;\n  } */\n  \n  .about {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    top:5rem;\n    z-index: 1;\n  }\n  .v-about {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    bottom:0rem;\n    z-index: 1;\n  }\n  \n  .about-btn {\n    margin-bottom: 10px;\n  }\n  \n  a.text-light {\n    color: #ffe6c8 !important;\n    text-decoration: none;\n    margin-left: 15px;\n  }\n  \n  a.text-light:hover {\n    text-decoration: underline;\n  }\n\n  .modal-content {\n    background: #E2EECC !important;\n    color: #1c2933  !important;\n    padding: 20px;\n    border-radius: 8px;\n    max-width: 80%; /* Prevent the modal from stretching too wide */\n    max-height: 90%; /* Prevent the modal from stretching too tall */\n    overflow-y: auto; /* Add scroll if content exceeds the height */\n    z-index: 1001;\n    position: relative;\n    border-radius: 0.5vw 0.5vw 0.5vw 0.5vw !important;\n  }\n  \n  .modal-header .close-button {\n    background: transparent;\n    border: none;\n    font-size: 1.5rem;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n    color: #333;\n  }\n\n.modal-image {\n  height: 100px;\n  border-radius: 50%;\n}\n.img-l {\n    width: 5rem !important;\n    display: flex;\n    height: 4rem;\n}\n.graph-svg{\n    width:25vw !important;\n}\n.text-left{\n  text-align: left !important;\n}\n\n/* videobackground.css */\n\n/* General styles for video and text */\n.v-video-overlay {\n  position: absolute;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  z-index: 1;\n  width: 100%;\n  padding: 0 15px;\n  background-color: rgba(0, 0, 0, 0.4);\n  height: 120%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  opacity: 0.5;\n}\n.video-overlay{\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  z-index: 1;\n  width: 90%;\n  height: 90%;\n  padding: 0 15px;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .video-overlay h1 {\n    font-size: 2rem; /* Smaller font size for mobile */\n  }\n\n  .video-overlay button {\n    font-size: 0.9rem; /* Adjust button font size */\n    padding: 0.75rem 1.25rem; /* Adjust padding for mobile */\n  }\n  .container-e .d-flex {\n    display: block !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .video-overlay h1 {\n    font-size: 1.8rem; /* Smaller font size for extra small screens */\n    margin-top: 5rem;\n  }\n\n  .video-overlay button {\n    font-size: 0.8rem; /* Even smaller button size */\n    padding: 0.5rem 1rem; /* Smaller padding for extra small screens */\n  }\n  .carousel-inner video {\n    height: auto; /* Make height adjust automatically on mobile */\n    max-height: 100vh; /* Ensure video doesn't exceed the viewport height */\n    margin-top: 5vh;    \n  }\n}\n\n/* Adjust for mobile responsiveness */\n@media (max-width: 768px) {\n  .carousel-inner video {\n    height: auto; /* Make height adjust automatically on mobile */\n    max-height: 100vh; /* Ensure video doesn't exceed the viewport height */\n    margin-top: 7rem;\n  }\n  #carouselExampleSlidesOnly{\n    height:35rem !important;\n  }\n  .video-overlay {\n    top: 30%;\n    transform: translate(-50%, -50%);\n    height: 80%,  !important;\n  }\n\n  .about {\n    margin-top: 20px; /* Reduce the gap between the button and the video */\n  }\n\n  /* Ensure no extra space after the button */\n  .carousel-item {\n    padding-bottom: 0;\n  }\n\n  /* Adjust the height to fit content and remove extra space */\n  .carousel-inner {\n    padding-bottom: 0;\n  }\n\n  /* Reduce the space below the video */\n  .m-4.mt-4 {\n    margin-bottom: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .about button {\n    display: grid;\n    align-content: center;\n  }\n  .para{\n    text-align: left !important;\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n  .navbar-brand{\n    margin-top:0.5rem !important;\n  }\n}\n@media (max-width: 768px) {\n  .row {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .about ,.v-about{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position:none;\n    top:8rem;\n  }\n  .video-bg-1{\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .mob-social-link{\n    position:relative;\n    top:15rem;\n  }\n}\n\n.scrollable-dropdown {\n  max-height: 150px; /* Adjust height as needed */\n  overflow-y: auto;  /* Enable vertical scrolling */\n}\n\n.video-overlay .dropdown-menu>li{\n  border-bottom: 1px solid #ccc !important;\n}\n.dropdown-toggle::after{\n  margin-left:1rem !important;\n}\n\n.btn-md:hover{\n  background-color: #1c2933;\n  color:#83B06D\n}\n.btn-hover-effect {\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.btn-hover-effect:hover {\n  background-color: var(--font-color) !important;\n  color: var(--background-color) !important;\n}\n\n@media (min-width: 768px) {\n  .flex-md-row {\n      flex-direction: row !important;\n      margin-top: 4rem !important;\n  }\n  .socialLinks{\n    position: absolute;\n    bottom: 0rem;\n    padding-right:5.5rem !important;\n    padding-left: 6.5rem !important;\n  }\n}\n\n/* General modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 6rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 80vw;\n  height: 100vh;\n  z-index: 1000;\n}\n\n\n.close-button {\n  font-size: 24px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n/* Responsive adjustments for mobile */\n@media (max-width: 768px) {\n  .modal-content {\n      max-width: 95%;\n      padding: 15px;\n  }\n\n  .img-l {\n      width: 8rem;\n      margin-bottom: 1rem;\n  }\n\n  .d-flex.mt-2.pr-4.gap-2 {\n      flex-direction: column;\n      align-items: center;\n      gap: 1rem;\n  }\n\n  .d-flex.flex-column.text-start {\n      width: auto;\n      margin-bottom: 1rem;\n      text-align: center;\n  }\n\n  .d-flex.flex-column.justify-content-center.text-left {\n      width: auto;\n      margin-top: 1rem;\n  }\n\n  .container-e.px-5.d-flex.flex-wrap.justify-content-around.pt-5 {\n      padding: 0;\n      margin-top: 2rem;\n      flex-direction: column;\n      align-items: center;\n  }\n\n  .graph-svg {\n      margin-bottom: 2rem;\n  }\n\n  .video-container {\n      margin-top: 1.5rem;\n  }\n\n  .montser-mdm {\n      font-size: 1rem !important;  /* Adjusted font size for mobile */\n  }\n\n  .mute-toggle {\n      top: 5px;\n      right: 5px;\n      padding: 5px;\n  }\n  .modal-overlay {\n    position: fixed; /* Stays fixed relative to the viewport */\n    top: 4rem;\n    left: 0;\n    width: 100vw; /* Full viewport width */\n    height: 80vh; /* Full viewport height */\n    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem; /* 1rem gap on all sides */\n    box-sizing: border-box; /* Includes padding in width and height calculations */\n    z-index: 1000; /* Ensures it's on top of other elements */\n}\n\n/* Modal Content */\n.modal-content {\n    background: white; /* Background color of the modal */\n    border-radius: 8px; /* Rounded corners */\n    max-width: 100%; /* Ensures it doesn't exceed the viewport */\n    width: 500px; /* Fixed width for larger screens */\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* Adds shadow for depth */\n    padding: 20px; /* Internal padding */\n    position: relative; /* For positioning child elements if needed */\n    overflow-y: auto; /* Allows scrolling if content is too tall */\n}\n\n}\n\n/* Responsive adjustments for smaller devices */\n@media (max-width: 600px) {\n  .modal-content {\n      width: 100%; /* Occupies full width minus the 1rem padding */\n      padding: 15px; /* Reduce padding */\n  }\n}\n\n.d-flex.mt-2.pr-4.gap-2 {\n  width: 100%;\n  margin-left: 2.5rem;  /* Apply margin-left for large screens */\n}\n\n/* Remove margin-left for small screens */\n@media (max-width: 768px) {\n  .d-flex.mt-2.pr-4.gap-2 {\n      margin-left: 0;  /* Remove margin-left for small screens */\n  }\n  .text-div {\n    width: 20rem;\n    margin-bottom: 1rem;  /* Add margin-bottom for small screens */\n}\n.text-container {\n  width: 19rem;\n  margin-right: 0rem !important;\n}\n.graph-svg {\n  width:20rem !important;\n  margin-bottom: 1rem !important;\n}\n.text-div span {\n  display: block !important;\n}\n.m-container-e{\n  margin-left:2rem;\n  margin-right: 1rem;\n}\n.socialLinks{\n  position: relative !important;\n  bottom:19rem !important;\n}\n}\n\n.text-div {\n  width: 20vw;\n  margin-bottom: 0; \n}\n\n.text-container {\n  width: 30vw;\n  margin-right: 3rem;\n  position: relative;\n}\n\n.container-e{\n  overflow-x: hidden;\n}\n\n@media(min-width: 992px) {\n  .navbar-expand-lg .navbar-nav {\n    margin-left:5rem !important;\n  }}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
